import React, {useContext, useEffect, useState} from 'react';
import {TableColumn, TableSettings} from "../../../tableSettings";
import AbstractListView, {
  DataFetchResult,ExportRowRenderer,ListCustomFilterRenderer,ListOrderBy,ListRowRenderer
} from "../../common/AbstractListView";
import constants from '../../../constants';
import {amsVoyageList,} from '../tableSettings';
import {Search} from "../../../filtering";
import {
  DateRenderer,DateTimeRenderer,NullableCheckboxIconRenderer,TextAlignLeftRenderer,TextRenderer
} from '../../../uiControls/SmartTableRenderers';
import JobListViewContext, { RightClickContext } from '../../common/JobListViewContext';
import { ActionButtonItem, borderColors, splitMenuItemsIntoSections } from '../../../ui/ActionButton';
import useFunctionKeys from '../../../hooks/useFunctionKeys';
import PrimaryButton from '../../../ui/PrimaryButton';
import {JobNames} from '../../../framework.core/JobNames';
import {AmsVoyageListItem} from '../../../fms.data/models/AmsVoyageListItem';
import * as XCol from '../../../framework.core/XExportColumn';
import useGlobalYesNoDialog from '../../../hooks/useGlobalYesNoDialog';
import IfmsModal from '../../../ui/IfmsModal';
import ViewVoyage from './implementation/ViewVoyage';
import CheckBoxUncontrolled from "../../../ui/CheckBoxUncontrolled";
import ListViewShortcutMenu from '../../common/ListViewShortcutMenu';
import ToolboxMenuItem from '../../../uiControls/ToolboxMenuItem';
import Menu, { IfmsMenuItem } from '../../../ui/menu/Menu';
import BlackInverseButton from '../../../ui/BlackInverseButton';
import voyageAll from '../../../img/DownloadAll.png';
import voyageNotDown from '../../../img/NotDownloaded.png';
import voyageDown from '../../../img/Downloaded.png';
import ApplicationContext from '../../../ApplicationContext';
import { ListFilterType } from '../../../fms.core/constants';
import { useHistory } from 'react-router';
import { openNewPage, NavigationType } from '../../../util/navigationHelpers';
import { nullableCheckBoxValue } from '../../common/commonExportFormat';

function BlockRenderer({value, row}: any) {
  /*const appContext = useContext(ApplicationContext);
  const jobListContext = useContext(JobListViewContext);

  async function updateConfirmed(newValue:boolean) {
    const updatedRow = await appContext.api.setCrdbConfirmed(row.original.id, newValue);
    jobListContext.updateDataRow(updatedRow);
  }

  return (
    <div style={{width: '100%', textAlign: 'center'}}>
      <CheckBoxUncontrolled initialValue={value as boolean} onChange={updateConfirmed} />
    </div>
  );*/
  return (
    <div style={{width: '100%', textAlign: 'center'}}>
      <CheckBoxUncontrolled initialValue={value as boolean} />
    </div>
  );
}

function useAMSVOperations() {
  const history = useHistory();
  const jobListContext = useContext(JobListViewContext);

  function switchToHblFor(voyage:AmsVoyageListItem|null) {
    if (!voyage) {
      return;
    }
    jobListContext.setFilterForScreenExternally('/common/joblistview/AMSH/ams', 
      'amsVoyageId', '', voyage.id, 'update', false, true);
    openNewPage(history, `/common/joblistview/AMSH/ams`, NavigationType.newPage);
  }
  return { switchToHblFor};
}

function useSelectedAMSVOperations() {
  const jobListContext = useContext(JobListViewContext);
  const { switchToHblFor} = useAMSVOperations();

  const selectedElement = jobListContext.selectedElement as AmsVoyageListItem|null;

  function view() {
    jobListContext.showPopupRow();
  }

  function switchToAmsHbl() {
    const selectedElement = jobListContext.selectedElement as AmsVoyageListItem;
    switchToHblFor(selectedElement);
  }

  return { selectedElement, view, switchToAmsHbl };
}

function RightClickMenu({dismiss}:{dismiss: VoidFunction}) {
  const { view, switchToAmsHbl } = useSelectedAMSVOperations();
  const jobListContext = useContext(JobListViewContext);
  // const selectedElement = jobListContext.selectedElement as OceanQuoteListItem;
  // const appContext = useContext(ApplicationContext);
  // const [showGlobalOkDialog] = useGlobalOkDialog();

  const items = [
    { label: 'View', shortcut: 'F9', separator: true },
    { label: 'Go to AMS HBL List', shortcut: 'F4', separator: false },
    { label: 'Search', shortcut: 'F5', separator: false },
    { label: constants.Doc_Server, shortcut: 'F8', separator: true, newCol: true },
  ];

  const menuItems: ActionButtonItem[] = items.map((i, index) =>({
    label: <ToolboxMenuItem width="190px" label={i.label} shortcut={i.shortcut} />,
    separator: i.separator,
    selected: false,
    newCol: i.newCol,
    index,
  }));

  function onMenuItemSelected(item:IfmsMenuItem) {
    switch (item.index) {
      case 0:
        view();
        break;
      case 1:
        switchToAmsHbl();
        break;
      case 2:
        jobListContext.triggerTableSearch('F5');
        break;
      case 3:
        jobListContext.setInfoAreaContent(jobListContext.infoAreaContent === 'memo' ? 'none' : 'memo');;
        break;
      case 4:
        jobListContext.reloadData();
        break;
      default:
        break;
    }
    dismiss();
  }

  return (
    <Menu
      variant="plain"
      specialMenu='rightClickContext'
      items={splitMenuItemsIntoSections(menuItems)}
      mode="vertical"
      onMenuItemSelected={onMenuItemSelected}
      subMenuStyle={{
        minWidth: 150,
        whiteSpace: 'nowrap',
      }}
      menuStyle={(i: number) => ({
        maxHeight: '300px',
        overflowY: 'hidden',
        padding: 0,
        borderTop: `3px solid ${borderColors[i % borderColors.length]}`,
        paddingTop: 10,
      })}
      dismiss={dismiss}
    />
  );
}

function ViListCommands() {
  const { selectedElement } = useSelectedAMSVOperations();
  const [ showGlobalYesNoDialog ] = useGlobalYesNoDialog();
  const [view, showView] = useState(false);
  const jobListContext = useContext(JobListViewContext);
  const appContext = useContext(ApplicationContext);
  const [listFilter, setListFilter] = useState('A');
  const history = useHistory();

  async function block(isBlock: boolean) {
    const doBlock = await showGlobalYesNoDialog(<p style={{ fontWeight: 'bold', fontSize: '13px' }}>Are you sure you want to {(isBlock ? "Block" : "Cancel block")}?</p>,false, 0, true)

    if (doBlock) {
      const id = selectedElement?.id;

      await appContext.api.block(JobNames.AMSVoyage, id, isBlock);

      jobListContext.reloadData();
    } else {
      return;
    }
  }
  function dismissView() {
    showView(false);
    jobListContext.dismissPopupRow();
  }

  async function changeVoyageListData(type: string) {
    setListFilter(type);
    const listFilterType = type === 'A' ? ListFilterType.All : (type === 'D' ? ListFilterType.Downloaded : ListFilterType.Virgin);
    const apiResult = await appContext.api.getListItems(JobNames.AMSVoyage,
      'AmsVoyageListItem',
      AmsVoyageListItem.calculateSearchParameters(jobListContext.search, AmsVoyageListItem.MapSearchFields),
      1,
      jobListContext.search.pageSize, 'AMS', listFilterType);

    if (!apiResult || !apiResult.entities || apiResult.entities.length <= 0) {
      jobListContext.setData && jobListContext.setData(AmsVoyageListItem.formatData([]), 0);
    }
    else
      jobListContext.setData && jobListContext.setData(AmsVoyageListItem.formatData(apiResult.entities), apiResult.totalCount);
  }

  async function viewDownloadView() {
    if (!selectedElement) {
      return;
    }

    const id = selectedElement.id;

    const viewUrl = `/oceanImport/download/${JobNames.AMSVoyage}/${id}`;

    openNewPage(history, viewUrl, NavigationType.newPage);
  }

  const allIconSelected = <img height="20px" width='20px' src={voyageAll} style={{ position: 'relative', filter: 'grayscale(100%) opacity(50%)' }} alt='' />
  const allIcon = <img height="20px" width='20px' src={voyageAll} style={{ position: 'relative' }} alt='' />
  const downloadedIconSelected = <img height="20px" width='20px' src={voyageDown} style={{ position: 'relative', filter: 'grayscale(100%) opacity(50%)' }} alt='' />
  const downloadedIcon = <img height="20px" width='20px' src={voyageDown} style={{ position: 'relative' }} alt='' />
  const notDownIconSelected = <img height="20px" width='20px' src={voyageNotDown} style={{ position: 'relative', filter: 'grayscale(100%) opacity(50%)' }} alt='' />
  const notDownIcon = <img height="20px" width='20px' src={voyageNotDown} style={{ position: 'relative' }} alt='' />

  return (
    <div className={!appContext.useDarkMode ? "ifms-common-vertical-separator" : "ifms-common-vertical-separator-darkmode"}>
      <div className="ifms-common-no-vertical-separator">
        <PrimaryButton
          size="regular"
          disabled={!selectedElement}
          name='voyage-list-view-button'
          onClick={() => showView(true)}
        >
            View
        </PrimaryButton>&nbsp;

        <PrimaryButton
          size="regular"
          disabled={!selectedElement}
          onClick={() => block(true)}
        >
          Block
        </PrimaryButton>&nbsp;

        <PrimaryButton
          size="regular"
          disabled={!selectedElement}
          onClick={() => block(false)}
        >
          Cancel Block
        </PrimaryButton>
      </div>
      <div className={!appContext.useDarkMode ? "ifms-common-vertical-separator" : "ifms-common-vertical-separator-darkmode"}>
        <PrimaryButton
          size="regular"
          disabled={!selectedElement}
          onClick={() => viewDownloadView()}
        >
          Download to OI
        </PrimaryButton>
      </div>
      <div className={!appContext.useDarkMode ? "ifms-common-vertical-separator" : "ifms-common-vertical-separator-darkmode"}>
        <BlackInverseButton
          size='small'
          data-tooltip="All"
          notsetbackcolorwhendisabled={'true'}
          disabled={listFilter === 'A'}
          onClick={async () => {
            await changeVoyageListData('A')
          }}>{listFilter === 'A'? allIconSelected : allIcon}
        </BlackInverseButton>&nbsp;
        <BlackInverseButton
          size='small'
          data-tooltip="Downloaded"
          notsetbackcolorwhendisabled={'true'}
          disabled={listFilter === 'D'}
          onClick={async () => {
            await changeVoyageListData('D')
          }}>{listFilter === 'D'? downloadedIconSelected :downloadedIcon}
        </BlackInverseButton>&nbsp;
        <BlackInverseButton
          size='small'
          data-tooltip="Not Downloaded"
          notsetbackcolorwhendisabled={'true'}
          disabled={listFilter === 'N'}
          onClick={async () => {
            await changeVoyageListData('N')
          }}>{listFilter === 'N'? notDownIconSelected :notDownIcon}
        </BlackInverseButton>&nbsp;
      </div>
      <IfmsModal isBlueHeader onCancel={dismissView} draggable isOpen={view || !!jobListContext.viewPopupRow} title="View Voyage" width="760px">
        <ViewVoyage onPopupClose={dismissView} selectedElementId={selectedElement?.id ?? ''} />
      </IfmsModal>
    </div>
  );
}

function ViListToolbar() {
  return (
    <>
      <ListViewShortcutMenu />
    </>
  );
}

function formatData(data:Array<AmsVoyageListItem>) {
  return data;
}

function ViListViewExtras() {
  useFunctionKeys({onFunction: onFunctionKey});
  const { view, switchToAmsHbl } = useSelectedAMSVOperations();

  const jobListContext = useContext(JobListViewContext);

  const [unprocessedFkey, setUnprocessedFkey] = useState<string|null>(null);

  useEffect(() => {
      if (!unprocessedFkey) {
        return;
      }

      doProcessFkey();
    },
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [unprocessedFkey]
  );

  function doProcessFkey() {
    if (unprocessedFkey === "F9") {
      view();
    } else if (unprocessedFkey === "F4") {
      switchToAmsHbl();
    } else if (unprocessedFkey === "F11") {
      jobListContext.reloadData();
    }

    setUnprocessedFkey(null);
  }

  function onFunctionKey(fkey:string) {
    if (['F4', 'F8', 'F9', 'F11'].indexOf(fkey) >= 0) {
      setUnprocessedFkey(fkey);
      return true;
    }

    return false;
  }

  return null;
}

/**
 * Concrete implementation for AMS Voyage List screen
 *
 * @class VoyageListView
 * @extends {AbstractListView}
 */
 class VoyageListView extends AbstractListView {
  async fetchAndFormatData(api: any, search: Search, opType :any): Promise<DataFetchResult> {
    const apiResult = await api.getListItems(JobNames.AMSVoyage, 'AmsVoyageListItem',
    AmsVoyageListItem.calculateSearchParameters(search,AmsVoyageListItem.MapSearchFields),
      1,
      search.pageSize,
      'AMS');

    if (!apiResult || !apiResult.entities || apiResult.entities.length <= 0) {
      return {data: [], totalCount: 0};
    }

    return { data: formatData(apiResult.entities), totalCount: apiResult.totalCount};
  }

  getCustomFilterRenderers(): ListCustomFilterRenderer[] {
    return [
    ];
  }

  getInfoAreaEntityId() {
    return constants.infoAreaEntity.oceanImportMbl;
  }

  getRowRenderers(): ListRowRenderer[] {
    return AmsVoyageListItem.getExportCollection().map(x => {
      const colRenderer:ListRowRenderer = { accessor: x.dataIndex, Cell: TextAlignLeftRenderer };
      if(x.align === XCol.XAlignType.Center) colRenderer.Cell = TextRenderer;
      if(x.dataIndex === "status") {
        colRenderer.Cell = () => <span></span>
        colRenderer.Header = () => <span></span>;
      }
      else if(x.type === XCol.XCellType.StrBool) colRenderer.Cell = BlockRenderer;
      else if(x.type === XCol.XCellType.Bool) colRenderer.Cell = NullableCheckboxIconRenderer;
      else if(x.type === XCol.XCellType.Date) colRenderer.Cell = DateRenderer;
      else if(x.type === XCol.XCellType.DateTime) colRenderer.Cell = DateTimeRenderer;
      return colRenderer;
    });
  }
  
  getExportRenderers(): ExportRowRenderer[] {
    const colRenderer = [];
    colRenderer.push({accessor: 'status', changedValue: (value: any)=> { return value['status'] === 'PC' ? 'Period Close' : ''}});
    colRenderer.push({accessor: 'block', changedValue: (value: any)=> { return nullableCheckBoxValue(value['block'])}});
    return colRenderer;
  }

  getDefaultOrderBy(): ListOrderBy {
    return {
      orderBy: 'id',
      orderByAscending: false,
    };
  }

  getTableSettings(): TableSettings {
    const tsettings = amsVoyageList;
    const cols = AmsVoyageListItem.getExportCollection();
    tsettings.columns = cols.map<TableColumn>(x => {
      return { ...x, accessor: x.dataIndex, Header: x.text, filterType: undefined, filterTypeV2: x.type};
    });

    return tsettings;
  }

  renderCommands() {
    return (
      <ViListCommands />
    );
  }

  renderBeforeConfigureButton() {
    return (
      <ViListToolbar />
    );
  }

  renderExtras() {
    return <ViListViewExtras />
  }

  getViewUrlFor() {
    return '';
  }

  hasViewPopup(): boolean {
    return true;
  }

  getListViewTitle() {
    return `AMS Voyage List`;
  };

  hasRightClickContext(): boolean {
    return true;
  }

  renderRightClickContext(context: RightClickContext, dismiss: VoidFunction): React.ReactNode {
    return <RightClickMenu dismiss={dismiss} />;
  }

  hasMemo(): boolean {
    return false;
  }
};

export default VoyageListView;